/**
 * Phase 6 · the deal screens' strings — the `settings` part: *Beállítások → Deal menedzsment*
 * (D1) and the client's contacts (D2). Spread into `HU` and `EN` in `../catalogue.ts`; a key in
 * one and not the other is a type error there.
 */
export const HU = {
  /* ── the section and its tabs ── */
  'dealSettings.tab.statuses': 'Deal státuszok',
  'dealSettings.tab.probabilities': 'Valószínűségek',
  'dealSettings.tab.reasons': 'Okok',
  'dealSettings.tab.forecast': 'Forecast · placeholder',
  'dealSettings.dealCount': '{count} deal',

  /* ── statuses ── */
  'dealSettings.statuses.title': 'Deal státuszok',
  'dealSettings.statuses.note':
    'Pontosan egy Megnyert és egy Elvesztett státusz lehet — a veszteség oka külön mező. A belépési kritérium a stepperen és a kanban oszlopfejen tooltipben jelenik meg.',
  'dealSettings.statuses.new': 'Új státusz',
  'dealSettings.statuses.edit': 'Státusz szerkesztése',
  'dealSettings.statuses.column.name': 'Név',
  'dealSettings.statuses.column.category': 'Típus',
  'dealSettings.statuses.column.probability': 'Javasolt esély',
  'dealSettings.statuses.column.rot': 'Rothadás (nap)',
  'dealSettings.statuses.column.criteria': 'Belépési kritérium',
  'dealSettings.statuses.column.deals': 'Deal',
  'dealSettings.statuses.empty': 'Még nincs deal státusz',
  'dealSettings.statuses.emptyBody': 'Vegyél fel egy nyitott státuszt, és a pipeline oszlopa lesz.',
  'dealSettings.statuses.field.name': 'Név',
  'dealSettings.statuses.field.namePlaceholder': 'pl. Ajánlat kiment',
  'dealSettings.statuses.field.probability': 'Javasolt esély (%)',
  'dealSettings.statuses.field.probabilityNote':
    'Státuszváltáskor ezt javasoljuk a dealnek, de a kézzel beállított esélyt nem írjuk felül.',
  'dealSettings.statuses.field.rot': 'Rothadás (nap)',
  'dealSettings.statuses.field.rotNote':
    'Ennyi nap mozdulatlanság után rothadónak jelöljük a dealt. 0: soha.',
  'dealSettings.statuses.field.criteria': 'Belépési kritérium',
  'dealSettings.statuses.field.criteriaPlaceholder': 'Mikor kerülhet ide egy deal?',
  'dealSettings.statuses.closedNote':
    'Lezáró státusz: nem törölhető és nem mozgatható, de a neve, a színe és a kritériuma szerkeszthető.',
  'dealSettings.statuses.delete': 'Státusz törlése',
  'dealSettings.statuses.deleteBody':
    'A(z) „{name}” státusz törlődik. Csak olyan státusz törölhető, amelyen nincs deal.',
  'dealSettings.statuses.error.name': 'Adj nevet a státusznak.',
  'dealSettings.statuses.error.probability': 'Az esély 0 és 100 közötti egész szám.',
  'dealSettings.statuses.error.rot': 'A rothadás 0 és 365 nap közötti egész szám.',

  /* ── probabilities ── */
  'dealSettings.probabilities.title': 'Valószínűségek',
  'dealSettings.probabilities.note':
    'A valószínűség kézi: státuszváltáskor javaslunk, de nem írjuk felül. A stage a folyamat, a valószínűség a megítélés.',
  'dealSettings.probabilities.new': 'Új valószínűség',
  'dealSettings.probabilities.edit': 'Valószínűség szerkesztése',
  'dealSettings.probabilities.column.pct': '%',
  'dealSettings.probabilities.column.name': 'Név',
  'dealSettings.probabilities.column.description': 'Mit jelent',
  'dealSettings.probabilities.empty': 'Még nincs valószínűségi lépcső',
  'dealSettings.probabilities.emptyBody':
    'A lépcsők adnak nevet egy-egy esélynek, hogy mindenki ugyanazt értse alatta.',
  'dealSettings.probabilities.field.pct': 'Valószínűség (%)',
  'dealSettings.probabilities.field.name': 'Név',
  'dealSettings.probabilities.field.namePlaceholder': 'pl. Ajánlat kiment',
  'dealSettings.probabilities.field.description': 'Mit jelent',
  'dealSettings.probabilities.field.descriptionPlaceholder': 'pl. Az ajánlat az ügyfélnél van.',
  'dealSettings.probabilities.delete': 'Valószínűség törlése',
  'dealSettings.probabilities.deleteBody':
    'A(z) „{name}” lépcső törlődik. A dealek esélye nem változik.',
  'dealSettings.probabilities.error.name': 'Adj nevet a lépcsőnek.',
  'dealSettings.probabilities.error.pct': 'A valószínűség 0 és 100 közötti egész szám.',

  /* ── reasons ── */
  'dealSettings.reasons.lostTitle': 'Elvesztés okai',
  'dealSettings.reasons.lostNote':
    'A kötelező megjegyzés ott hasznos, ahol az ok önmagában nem mond semmit — például az „Egyéb”-nél. Törölni csak olyan okot lehet, amin nincs deal.',
  'dealSettings.reasons.wonTitle': 'Megnyerés okai',
  'dealSettings.reasons.wonNote':
    'Opcionális kitöltés — de ettől lesz kétoldalú a win/loss elemzés.',
  'dealSettings.reasons.newLost': 'Új elvesztési ok',
  'dealSettings.reasons.newWon': 'Új megnyerési ok',
  'dealSettings.reasons.edit': 'Ok szerkesztése',
  'dealSettings.reasons.column.name': 'Ok',
  'dealSettings.reasons.column.deals': 'Deal',
  'dealSettings.reasons.column.needsNote': 'Megjegyzés kötelező',
  'dealSettings.reasons.column.active': 'Aktív',
  'dealSettings.reasons.noGroup': 'Csoport nélkül',
  'dealSettings.reasons.needsNoteFor': '{name}: megjegyzés kötelező',
  'dealSettings.reasons.activeFor': '{name}: aktív',
  'dealSettings.reasons.emptyLost': 'Még nincs elvesztési ok',
  'dealSettings.reasons.emptyWon': 'Még nincs megnyerési ok',
  'dealSettings.reasons.emptyBody': 'Az okokból lesz a win/loss elemzés.',
  'dealSettings.reasons.field.name': 'Ok',
  'dealSettings.reasons.field.namePlaceholder': 'pl. Túl drága',
  'dealSettings.reasons.field.group': 'Csoport',
  'dealSettings.reasons.field.groupPlaceholder': 'pl. Ár',
  'dealSettings.reasons.field.newGroup': 'Új csoport',
  'dealSettings.reasons.field.needsNote': 'Megjegyzés kötelező',
  'dealSettings.reasons.field.needsNoteNote': 'Lezáráskor csak megjegyzéssel együtt választható.',
  'dealSettings.reasons.field.active': 'Aktív',
  'dealSettings.reasons.field.activeNote':
    'Inaktív okot lezáráskor nem lehet választani; a korábbi dealek megtartják.',
  'dealSettings.reasons.delete': 'Ok törlése',
  'dealSettings.reasons.deleteBody': 'A(z) „{name}” ok törlődik.',
  'dealSettings.reasons.error.name': 'Adj nevet az oknak.',

  /* ── forecast · placeholder ── */
  'dealSettings.forecast.categoriesTitle': 'Forecast kategóriák',
  'dealSettings.forecast.categoriesNote':
    'A kategória alapból a valószínűségből származik (≥75% → Bekötött, ≥40% → Legjobb eset, alatta Pipeline), de kézzel felülírható — a felülírás jelölt marad.',
  'dealSettings.forecast.desc.commit': 'A vezető rátette a nevét — a negyedéves számban benne van.',
  'dealSettings.forecast.desc.best_case': 'Reális, de még nem vállalás.',
  'dealSettings.forecast.desc.pipeline': 'Él, de messze van a döntéstől.',
  'dealSettings.forecast.desc.omitted': 'A forecastból szándékosan kivéve.',
  'dealSettings.forecast.column.category': 'Kategória',
  'dealSettings.forecast.column.meaning': 'Mit jelent',
  'dealSettings.forecast.column.count': 'Deal',
  'dealSettings.forecast.column.value': 'Érték',
  'dealSettings.forecast.disciplineTitle': 'Fegyelem és cél',
  'dealSettings.forecast.nextStep': 'Következő lépés kötelező nyitott dealen',
  'dealSettings.forecast.nextStepNote':
    'Nem blokkol: figyelmeztető pötty a listában és a kártyán, plusz riasztás. Elmagyarázzuk, nem tiltjuk.',
  'dealSettings.forecast.tentative': 'Lágy foglalás valós emberen',
  'dealSettings.forecast.tentativeNote':
    'A deal-igény megjelenhet valós emberen sávozott, tentative allokációként — alapból elrejtve, a kihasználtságba soha nem számít.',
  'dealSettings.forecast.target': 'Negyedéves cél ({currency})',
  'dealSettings.forecast.targetNote': 'Ebből számoljuk a pipeline-fedezetet a forecast nézetben.',
  'dealSettings.forecast.error.target': 'Adj meg egy nem negatív összeget.',
  'dealSettings.profiles.title': 'Placeholder profilok',
  'dealSettings.profiles.note':
    'A díjak itt élnek egy helyen, a példányok dealenként jönnek létre — a terv szabadon szabható, a kalkuláció mégis konzisztens.',
  'dealSettings.profiles.new': 'Új profil',
  'dealSettings.profiles.edit': 'Profil szerkesztése',
  'dealSettings.profiles.column.role': 'Szerep',
  'dealSettings.profiles.column.seniority': 'Szint',
  'dealSettings.profiles.column.cost': 'Költségdíj',
  'dealSettings.profiles.column.target': 'Céldíj',
  'dealSettings.profiles.column.usage': 'Használat',
  'dealSettings.profiles.empty': 'Még nincs placeholder profil',
  'dealSettings.profiles.emptyBody':
    'Egy profil egy szerep és egy szint díja; a dealek erőforrás-tervében ebből lesz placeholder.',
  'dealSettings.profiles.field.role': 'Projekt szerep',
  'dealSettings.profiles.field.pickRole': 'Válassz szerepet',
  'dealSettings.profiles.field.noRoles':
    'Még nincs projekt szerep — előbb vegyél fel egyet a Projekt szerepek beállításnál.',
  'dealSettings.profiles.field.seniority': 'Szint',
  'dealSettings.profiles.field.cost': 'Költségdíj ({currency})',
  'dealSettings.profiles.field.target': 'Céldíj ({currency})',
  'dealSettings.profiles.delete': 'Profil törlése',
  'dealSettings.profiles.deleteBody': 'A(z) „{name}” profil törlődik.',
  'dealSettings.profiles.error.role': 'Válassz projekt szerepet.',
  'dealSettings.profiles.error.rate': 'Mindkét díj nem negatív összeg.',

  /* ── refusals ── */
  'dealSettings.error.inUse.status': 'Ezen a státuszon még van deal — előbb tedd át őket máshová.',
  'dealSettings.error.inUse.reason':
    'Ezt az okot dealek hivatkozzák, ezért nem törölhető. Kapcsold inaktívra.',
  'dealSettings.error.inUse.profile':
    'Ebből a profilból már készült placeholder, ezért nem törölhető.',
  'dealSettings.error.inUse.other': 'Ezt még használják, ezért nem törölhető.',
  'dealSettings.error.closedStatus': 'A Megnyert és az Elvesztett státusz nem törölhető.',
  'dealSettings.error.lastOpen': 'Legalább egy nyitott státusznak maradnia kell.',
  'dealSettings.error.nameTaken.status': 'Már van ilyen nevű státusz.',
  'dealSettings.error.nameTaken.probability': 'Ez a százalék már szerepel a lépcsők között.',
  'dealSettings.error.nameTaken.reason': 'Már van ilyen nevű ok.',
  'dealSettings.error.nameTaken.profile': 'Ehhez a szerephez már van ilyen szintű profil.',
  'dealSettings.error.stale':
    'Valaki más közben módosította. Betöltöttük a frisset — próbáld újra.',
  'dealSettings.error.notFound': 'Ez az elem közben törlődött.',
  'dealSettings.error.invalid': 'Ellenőrizd a mezőket.',
  'dealSettings.error.denied': 'Ehhez nincs jogosultságod.',

  /* ── contacts (DM-2) ── */
  'contacts.tabs': 'Az ügyfél részei',
  'contacts.tab.details': 'Adatok',
  'contacts.tab.contacts': 'Kapcsolattartók',
  'contacts.edit': 'Kapcsolattartó szerkesztése',
  'contacts.hint': 'A kapcsolattartó az ügyfélhez tartozik, és minden dealjénél választható.',
  'contacts.field.name': 'Név',
  'contacts.field.namePlaceholder': 'pl. Kovács Anna',
  'contacts.field.title': 'Beosztás',
  'contacts.field.titlePlaceholder': 'pl. IT vezető',
  'contacts.field.email': 'E-mail',
  'contacts.field.phone': 'Telefon',
  'contacts.field.primary': 'Elsődleges kapcsolattartó',
  'contacts.field.primaryNote': 'Új dealnél őt választjuk elsőként. Ügyfelenként egy lehet.',
  'contacts.primary': 'Elsődleges',
  'contacts.empty': 'Még nincs kapcsolattartó',
  'contacts.emptyBody': 'Vegyél fel egyet, és a cég dealjeinél választható lesz.',
  'contacts.loadFailed': 'Nem sikerült betölteni a kapcsolattartókat.',
  'contacts.retry': 'Újra',
  'contacts.delete': 'Kapcsolattartó törlése',
  'contacts.deleteBody':
    '{name} törlődik. A dealek, amelyeken szerepel, megmaradnak, csak kapcsolattartó nélkül.',
  'contacts.error.name': 'Add meg a kapcsolattartó nevét.',
  'contacts.error.email': 'Ez nem tűnik e-mail-címnek.',
  'contacts.error.notFound': 'Az ügyfél vagy a kapcsolattartó közben törlődött.',
  'contacts.error.denied':
    'Kapcsolattartót csak deal- vagy ügyfélkezelési joggal lehet módosítani.',
} as const;

export const EN: Record<keyof typeof HU, string> = {
  'dealSettings.tab.statuses': 'Deal statuses',
  'dealSettings.tab.probabilities': 'Probabilities',
  'dealSettings.tab.reasons': 'Reasons',
  'dealSettings.tab.forecast': 'Forecast · placeholder',
  'dealSettings.dealCount': '{count} deals',

  'dealSettings.statuses.title': 'Deal statuses',
  'dealSettings.statuses.note':
    'There is exactly one Won and one Lost status — why a deal was lost is a separate field. The entry criterion shows as a tooltip on the stepper and the kanban column header.',
  'dealSettings.statuses.new': 'New status',
  'dealSettings.statuses.edit': 'Edit status',
  'dealSettings.statuses.column.name': 'Name',
  'dealSettings.statuses.column.category': 'Type',
  'dealSettings.statuses.column.probability': 'Suggested probability',
  'dealSettings.statuses.column.rot': 'Rots after (days)',
  'dealSettings.statuses.column.criteria': 'Entry criterion',
  'dealSettings.statuses.column.deals': 'Deals',
  'dealSettings.statuses.empty': 'No deal statuses yet',
  'dealSettings.statuses.emptyBody': 'Add an open status and it becomes a pipeline column.',
  'dealSettings.statuses.field.name': 'Name',
  'dealSettings.statuses.field.namePlaceholder': 'e.g. Proposal sent',
  'dealSettings.statuses.field.probability': 'Suggested probability (%)',
  'dealSettings.statuses.field.probabilityNote':
    'Suggested to the deal when it enters this status; a probability set by hand is never overwritten.',
  'dealSettings.statuses.field.rot': 'Rots after (days)',
  'dealSettings.statuses.field.rotNote':
    'A deal that has not moved for this many days is marked as rotting. 0: never.',
  'dealSettings.statuses.field.criteria': 'Entry criterion',
  'dealSettings.statuses.field.criteriaPlaceholder': 'When may a deal enter this status?',
  'dealSettings.statuses.closedNote':
    'A closing status: it cannot be deleted or moved, but its name, colour and criterion can be edited.',
  'dealSettings.statuses.delete': 'Delete status',
  'dealSettings.statuses.deleteBody':
    'The status “{name}” will be deleted. Only a status with no deals in it can be deleted.',
  'dealSettings.statuses.error.name': 'Give the status a name.',
  'dealSettings.statuses.error.probability': 'The probability is a whole number from 0 to 100.',
  'dealSettings.statuses.error.rot': 'Rotting is a whole number of days from 0 to 365.',

  'dealSettings.probabilities.title': 'Probabilities',
  'dealSettings.probabilities.note':
    'Probability is a judgement: we suggest one when the status changes, but never overwrite it. The stage is the process; the probability is the call.',
  'dealSettings.probabilities.new': 'New probability',
  'dealSettings.probabilities.edit': 'Edit probability',
  'dealSettings.probabilities.column.pct': '%',
  'dealSettings.probabilities.column.name': 'Name',
  'dealSettings.probabilities.column.description': 'What it means',
  'dealSettings.probabilities.empty': 'No probability steps yet',
  'dealSettings.probabilities.emptyBody':
    'Steps name a probability, so everybody means the same thing by it.',
  'dealSettings.probabilities.field.pct': 'Probability (%)',
  'dealSettings.probabilities.field.name': 'Name',
  'dealSettings.probabilities.field.namePlaceholder': 'e.g. Proposal sent',
  'dealSettings.probabilities.field.description': 'What it means',
  'dealSettings.probabilities.field.descriptionPlaceholder': 'e.g. The client has the proposal.',
  'dealSettings.probabilities.delete': 'Delete probability',
  'dealSettings.probabilities.deleteBody':
    'The step “{name}” will be deleted. No deal’s probability changes.',
  'dealSettings.probabilities.error.name': 'Give the step a name.',
  'dealSettings.probabilities.error.pct': 'The probability is a whole number from 0 to 100.',

  'dealSettings.reasons.lostTitle': 'Reasons for losing',
  'dealSettings.reasons.lostNote':
    'A required note helps where the reason says nothing on its own — “Other”, for instance. Only a reason no deal cites can be deleted.',
  'dealSettings.reasons.wonTitle': 'Reasons for winning',
  'dealSettings.reasons.wonNote':
    'Optional to fill in — but it is what makes win/loss analysis two-sided.',
  'dealSettings.reasons.newLost': 'New loss reason',
  'dealSettings.reasons.newWon': 'New win reason',
  'dealSettings.reasons.edit': 'Edit reason',
  'dealSettings.reasons.column.name': 'Reason',
  'dealSettings.reasons.column.deals': 'Deals',
  'dealSettings.reasons.column.needsNote': 'Note required',
  'dealSettings.reasons.column.active': 'Active',
  'dealSettings.reasons.noGroup': 'Ungrouped',
  'dealSettings.reasons.needsNoteFor': '{name}: note required',
  'dealSettings.reasons.activeFor': '{name}: active',
  'dealSettings.reasons.emptyLost': 'No loss reasons yet',
  'dealSettings.reasons.emptyWon': 'No win reasons yet',
  'dealSettings.reasons.emptyBody': 'Reasons are what win/loss analysis is made of.',
  'dealSettings.reasons.field.name': 'Reason',
  'dealSettings.reasons.field.namePlaceholder': 'e.g. Too expensive',
  'dealSettings.reasons.field.group': 'Group',
  'dealSettings.reasons.field.groupPlaceholder': 'e.g. Price',
  'dealSettings.reasons.field.newGroup': 'New group',
  'dealSettings.reasons.field.needsNote': 'Note required',
  'dealSettings.reasons.field.needsNoteNote':
    'When closing a deal it can only be picked with a note.',
  'dealSettings.reasons.field.active': 'Active',
  'dealSettings.reasons.field.activeNote':
    'An inactive reason cannot be picked when closing a deal; deals that already cite it keep it.',
  'dealSettings.reasons.delete': 'Delete reason',
  'dealSettings.reasons.deleteBody': 'The reason “{name}” will be deleted.',
  'dealSettings.reasons.error.name': 'Give the reason a name.',

  'dealSettings.forecast.categoriesTitle': 'Forecast categories',
  'dealSettings.forecast.categoriesNote':
    'By default the category follows the probability (≥75% → Commit, ≥40% → Best case, below that Pipeline), but it can be overridden by hand — and the override stays marked.',
  'dealSettings.forecast.desc.commit':
    'The owner has put their name to it — it is in the quarter’s number.',
  'dealSettings.forecast.desc.best_case': 'Realistic, but not yet a commitment.',
  'dealSettings.forecast.desc.pipeline': 'Alive, but far from a decision.',
  'dealSettings.forecast.desc.omitted': 'Deliberately left out of the forecast.',
  'dealSettings.forecast.column.category': 'Category',
  'dealSettings.forecast.column.meaning': 'What it means',
  'dealSettings.forecast.column.count': 'Deals',
  'dealSettings.forecast.column.value': 'Value',
  'dealSettings.forecast.disciplineTitle': 'Discipline and target',
  'dealSettings.forecast.nextStep': 'A next step is required on an open deal',
  'dealSettings.forecast.nextStepNote':
    'It does not block: a warning dot in the list and on the card, plus an alert. We explain, we do not forbid.',
  'dealSettings.forecast.tentative': 'Tentative booking of real people',
  'dealSettings.forecast.tentativeNote':
    'A deal’s demand can appear on real people as hatched, tentative allocations — hidden by default, never counted in utilisation.',
  'dealSettings.forecast.target': 'Quarterly target ({currency})',
  'dealSettings.forecast.targetNote': 'The forecast view measures pipeline coverage against it.',
  'dealSettings.forecast.error.target': 'Enter an amount that is not negative.',
  'dealSettings.profiles.title': 'Placeholder profiles',
  'dealSettings.profiles.note':
    'The rates live here, in one place; the instances are made per deal — the plan is free to shape, and the calculation still stays consistent.',
  'dealSettings.profiles.new': 'New profile',
  'dealSettings.profiles.edit': 'Edit profile',
  'dealSettings.profiles.column.role': 'Role',
  'dealSettings.profiles.column.seniority': 'Seniority',
  'dealSettings.profiles.column.cost': 'Cost rate',
  'dealSettings.profiles.column.target': 'Target rate',
  'dealSettings.profiles.column.usage': 'Usage',
  'dealSettings.profiles.empty': 'No placeholder profiles yet',
  'dealSettings.profiles.emptyBody':
    'A profile is the rate for one role at one seniority; a deal’s resource plan makes placeholders from it.',
  'dealSettings.profiles.field.role': 'Project role',
  'dealSettings.profiles.field.pickRole': 'Pick a role',
  'dealSettings.profiles.field.noRoles':
    'There are no project roles yet — add one under Project roles first.',
  'dealSettings.profiles.field.seniority': 'Seniority',
  'dealSettings.profiles.field.cost': 'Cost rate ({currency})',
  'dealSettings.profiles.field.target': 'Target rate ({currency})',
  'dealSettings.profiles.delete': 'Delete profile',
  'dealSettings.profiles.deleteBody': 'The profile “{name}” will be deleted.',
  'dealSettings.profiles.error.role': 'Pick a project role.',
  'dealSettings.profiles.error.rate': 'Both rates must be amounts that are not negative.',

  'dealSettings.error.inUse.status':
    'This status still has deals in it — move them elsewhere first.',
  'dealSettings.error.inUse.reason':
    'Deals cite this reason, so it cannot be deleted. Switch it to inactive instead.',
  'dealSettings.error.inUse.profile':
    'Placeholders have already been made from this profile, so it cannot be deleted.',
  'dealSettings.error.inUse.other': 'This is still in use, so it cannot be deleted.',
  'dealSettings.error.closedStatus': 'The Won and Lost statuses cannot be deleted.',
  'dealSettings.error.lastOpen': 'At least one open status has to remain.',
  'dealSettings.error.nameTaken.status': 'A status with this name already exists.',
  'dealSettings.error.nameTaken.probability': 'This percentage is already one of the steps.',
  'dealSettings.error.nameTaken.reason': 'A reason with this name already exists.',
  'dealSettings.error.nameTaken.profile': 'This role already has a profile at this seniority.',
  'dealSettings.error.stale': 'Somebody else changed this. The latest is loaded — try again.',
  'dealSettings.error.notFound': 'This was deleted in the meantime.',
  'dealSettings.error.invalid': 'Check the fields.',
  'dealSettings.error.denied': 'You do not have permission to do this.',

  'contacts.tabs': 'Client sections',
  'contacts.tab.details': 'Details',
  'contacts.tab.contacts': 'Contacts',
  'contacts.edit': 'Edit contact',
  'contacts.hint': 'A contact belongs to the client and can be picked on any of its deals.',
  'contacts.field.name': 'Name',
  'contacts.field.namePlaceholder': 'e.g. Anna Kovács',
  'contacts.field.title': 'Job title',
  'contacts.field.titlePlaceholder': 'e.g. Head of IT',
  'contacts.field.email': 'Email',
  'contacts.field.phone': 'Phone',
  'contacts.field.primary': 'Primary contact',
  'contacts.field.primaryNote': 'Picked first on a new deal. A client has at most one.',
  'contacts.primary': 'Primary',
  'contacts.empty': 'No contacts yet',
  'contacts.emptyBody': 'Add one and it can be picked on this client’s deals.',
  'contacts.loadFailed': 'The contacts could not be loaded.',
  'contacts.retry': 'Retry',
  'contacts.delete': 'Delete contact',
  'contacts.deleteBody':
    '{name} will be deleted. Deals that name them stay, just without a contact.',
  'contacts.error.name': 'Enter the contact’s name.',
  'contacts.error.email': 'That does not look like an email address.',
  'contacts.error.notFound': 'The client or the contact was deleted in the meantime.',
  'contacts.error.denied': 'Changing contacts needs deal or client management rights.',
};
